<section class="loa-tracking" data-testid="loa-tracking-section">
  <div class="loa-tracking__header">
    <h2 class="loa-tracking__title">Letter of Adherence Tracking</h2>
    <p class="loa-tracking__subtitle">
      Track and manage Letter of Adherence documents for this Legal Entity
    </p>
  </div>

  <div class="loa-tracking__content">
    <div class="loa-tracking__field">
      <span class="loa-tracking__label">Letter of Adherence:</span>
      <div class="loa-tracking__documents-list" *ngIf="loaDocuments && loaDocuments.length > 0">
        <div
          *ngFor="let doc of loaDocuments"
          class="loa-tracking__document-row"
          data-testid="loa-document-row"
        >
          <a
            class="loa-tracking__document-link"
            data-testid="loa-document-link"
            (click)="downloadDocument(doc)"
            role="button"
            tabindex="0"
            (keydown.enter)="downloadDocument(doc)"
            (keydown.space)="downloadDocument(doc)"
          >
            <span class="loa-tracking__document-text">{{ doc.name }}</span>
            <span class="material-symbols-outlined loa-tracking__document-icon">draft</span>
          </a>
          <button
            *ngIf="canDeleteDocument(doc)"
            class="loa-tracking__delete-btn"
            data-testid="loa-delete-btn"
            (click)="requestDeleteDocument(doc)"
            aria-label="Remove document"
          >
            <span class="material-symbols-outlined loa-tracking__delete-icon">close</span>
          </button>
        </div>
      </div>
      <div
        class="loa-tracking__empty-state"
        data-testid="loa-empty-state"
        *ngIf="!loaDocuments || loaDocuments.length === 0"
      >
        No documents uploaded
      </div>
      <app-az-button
        *ngIf="canShowUploadButton"
        data-testid="loa-upload-btn"
        [label]="'Upload'"
        [icon]="'upload'"
        (click)="openModal()"
      ></app-az-button>
    </div>

    <div class="loa-tracking__field">
      <span class="loa-tracking__label">Date LOA Signed:</span>
      <div class="loa-tracking__date-text" data-testid="loa-date-signed">
        {{ documentDate || '--' }}
      </div>
    </div>
  </div>
</section>

<app-az-document-update-modal
  [isOpen]="isModalOpen"
  [documentTypes]="uploadDocumentTypes"
  [allowedFileTypes]="['pdf', 'docx']"
  [isUploading]="isUploading"
  [showCommentBox]="true"
  (close)="closeModal()"
  (upload)="handleUpload($event)"
></app-az-document-update-modal>

<app-status-change-modal
  #deleteModal
  [isOpen]="isDeleteModalOpen"
  [title]="'Delete Document'"
  [initialState]="'custom-confirm'"
  (customNo)="onDeleteCancelled()"
  (customYes)="onDeleteConfirmed()"
  (close)="onDeleteModalClosed()"
></app-status-change-modal>

<app-status-change-modal
  #uploadSuccessModal
  [isOpen]="isUploadSuccessModalOpen"
  [title]="'BCR Complete'"
  [initialState]="'success'"
  (close)="onUploadSuccessModalClosed()"
></app-status-change-modal>
